<ui-grid [data]="data$ | async"
          [selectable]="false"
          [loading]="loading$ | async">
    <ui-grid-column [sortable]="true"
                    [title]="'robot_versions_grid_name' | translate"
                    property="robot.name"
                    width="50%">
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [title]="'robot_versions_grid_version' | translate"
                    property="robot.version"
                    sort="desc"
                    width="50%">
        <ng-template let-entry="data">
            <ui-machine-robot-versions-display [robotVersions]="[entry.robot]">
            </ui-machine-robot-versions-display>
        </ng-template>
    </ui-grid-column>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
